import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import * as Types from './purchasePlus_graphql'

export const ProductModalProductDetailsProductFragmentDoc = gql`
  fragment ProductModalProductDetailsProduct on ProductInterface {
    id
    itemDescription
    brand
    itemSize
    itemMeasure
    itemPackName
    concatenatedSellUnit
    canonicalProductId
    productCode
    createdAt
    outOfStock
    supplierCode: productCode(organisationId: $supplierId)
    owner {
      id
      name
    }
    category {
      id
      name
      parent {
        id
        name
      }
    }
  }
` as unknown as DocumentNode<Types.ProductModalProductDetailsProductFragment, unknown>
